var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "-8 -8 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6H31V-6H9V6ZM34 9V31H46V9H34ZM31 34H9V46H31V34ZM6 31V9H-6V31H6ZM9 34C7.34315 34 6 32.6569 6 31H-6C-6 39.2843 0.715731 46 9 46V34ZM34 31C34 32.6569 32.6569 34 31 34V46C39.2843 46 46 39.2843 46 31H34ZM31 6C32.6569 6 34 7.34315 34 9H46C46 0.715728 39.2843 -6 31 -6V6ZM9 -6C0.715728 -6 -6 0.715731 -6 9H6C6 7.34315 7.34315 6 9 6V-6Z",
    fill: "#8B8B8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareEmpty);
export default __webpack_public_path__ + "static/media/square-empty.b2a3cbea.svg";
export { ForwardRef as ReactComponent };